import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { IReportsRepository } from "../../../domain/repositories/reports-repository";
import { ReportsFilterContext } from "./ReportsFilterProvider";
import { TVisitorsFunnelResponse } from "domain/entities/visitors-funnel-response";

type TVisitorsFunnelProps = {
  requestParamsIndex: number;
  children: React.ReactNode;
  reportsDatasource?: IReportsRepository;
};

export type VisitorsFunnelProviderState = {
  requestParamsIndex: number;
  visitorsFunnelData?: TVisitorsFunnelResponse;
  isLoading: boolean;
};

const initContext: VisitorsFunnelProviderState = {
  requestParamsIndex: 0,
  isLoading: true,
};
export const VisitorsFunnelContext = createContext(initContext);

export const VisitorsFunnelProvider = ({
  requestParamsIndex,
  reportsDatasource,
  children,
}: TVisitorsFunnelProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [visitorsFunnelData, setVisitorsFunnelData] =
    useState<TVisitorsFunnelResponse>();

  const { requestParams } = useContext(ReportsFilterContext);
  const currentRequestParams = requestParams[requestParamsIndex];

  useEffect(() => {
    setIsLoading(true);
    reportsDatasource
      ?.getVisitorsFunnel(currentRequestParams)
      .then(setVisitorsFunnelData)
      .then(() => setIsLoading(false));
  }, [currentRequestParams]);

  return (
    <VisitorsFunnelContext.Provider
      value={{
        requestParamsIndex,
        visitorsFunnelData,
        isLoading,
      }}
    >
      {children}
    </VisitorsFunnelContext.Provider>
  );
};
